import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EngagementHttpService } from 'src/app/http/engagement-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { ContactViewModalComponent } from 'src/app/shared/modals/contact-view-modal/contact-view-modal.component';
import { ProductReviewModalComponent } from 'src/app/shared/modals/product-review-modal/product-review-modal.component';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styles: [],
})
export class ReviewComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private engagementHttpService: EngagementHttpService) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    viewReview(item: any) {
        let contactModal = this.modalService.open(ProductReviewModalComponent, { windowClass: 'review-modal' });
        contactModal.componentInstance.review = item;
    }

    confirmTogglePublish(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Publish' : 'Unpublish'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'publish' : 'unpublish'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.togglePublish(item, value);
                }
            },
            () => {}
        );
    }

    togglePublish(item: any, value: any) {
        this.engagementHttpService.togglePublishReview(item.productReviewsId, value).subscribe(() => {
            this.togglePublishItem(item.productReviewsId, value);
            this.alert.addAlert({ type: 'success', message: `Review ${value ? 'publish' : 'unPublish'} successfully` });
        });
    }

    togglePublishItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.productReviewsId === itemId);
        item.isPublished = value;
        this.items = this.tempItems;
    }
}
